<template>
    <nav id="sidebar" style="background-color: #343a40" :class="{ active: toggle}">
        <div class="sidebar-header">
            <b-img @click="backMenuTodefault" :src="empresaLogo" height="100" width="210" rounded center fluid alt="Fluid image"></b-img>
        </div>
        <b-list-group>
            <template v-if="currentMenu == 0">
                <div v-for="sidebar in Object.values(sidebarItems.main) " :key="sidebar.id">
                    <!-- if the navbar has declared rules to display and complies with them, they will be displayed. -->
                    <div v-if='sidebar.requiredValidation'>
                        <div v-if='validateRules(sidebar.validationRules)'>
                            <sidebar-item 
                                :sidebar-icon="sidebar.sidebarIcon" 
                                :sidebar-name="sidebar.sidebarName" 
                                :route-to="sidebar.routeTo" 
                                :recursive="sidebar.recursive"
                                @change-menu="changeMenu(sidebar)"
                            />
                        </div>
                    </div>
                    <div v-else>
                        <sidebar-item 
                            :sidebar-icon="sidebar.sidebarIcon" 
                            :sidebar-name="sidebar.sidebarName" 
                            :route-to="sidebar.routeTo" 
                            :recursive="sidebar.recursive"
                            @change-menu="changeMenu(sidebar)"
                        />
                    </div>
                </div>
                <b-list-group-item  href="#" @click="logout"
                    class="d-flex justify-content-between align-items-center text-white">
                    <div>
                        <h5> 
                            <b-icon icon="power"></b-icon>
                            Salir
                        </h5>
                    </div>
                </b-list-group-item>
            </template>
            <template v-if="currentMenu == 1">
                <div v-for="sidebar in sidebarItems.items_config" :key="sidebar.id">
                    <!-- if the navbar has declared rules to display and complies with them, they will be displayed. -->
                    <div v-if='sidebar.requiredValidation'>
                        <div v-if='validateRules(sidebar.validationRules)'>
                            <sidebar-item 
                                :sidebar-icon="sidebar.sidebarIcon" 
                                :sidebar-name="sidebar.sidebarName" 
                                :route-to="sidebar.routeTo" 
                                :recursive="sidebar.recursive"
                                @change-menu="changeMenu(sidebar)"
                            />
                        </div>
                    </div>
                    <div v-else>
                        <sidebar-item 
                            :sidebar-icon="sidebar.sidebarIcon" 
                            :sidebar-name="sidebar.sidebarName" 
                            :route-to="sidebar.routeTo" 
                            :recursive="sidebar.recursive"
                            @change-menu="changeMenu(sidebar)"
                        />
                    </div>
                </div>
            </template>
        </b-list-group> 

        <supplierCategories v-for="(categorySupplier, indexSupplier) in categoriesHoyostool" 
            :key="categorySupplier.category_code"
            :indice="indexSupplier" 
            :mapMenu="mapMenu" 
            :category="categorySupplier" 
            v-model="currentMenu"/>
        
        <showCategories v-for="(category, index) in categoriesEmpresa" 
            :key="category.id" 
            :indice="index" 
            :category="category" 
            :mapMenu="mapMenu" 
            v-model="currentMenu"/>
    </nav>
</template>

<script>
import SupplierCategories from './components/SupplierCategories.vue'
import showCategories from './components/ShowCategories.vue'
import SidebarItem from './components/SidebarItem.vue'
import { mapState, mapActions } from 'vuex'
import sidebarMenu from './components/sidebarObject.js'
export default {
     computed: {
        ...mapState('configuration', ['background', 'empresaLogo', 'toggle', 'categoriesHoyostool', 'categoriesEmpresa', 'opcionPrecioPropio']),
        ...mapState('auth', ['user', 'empresa']),
    },
    data(){
        return{
            currentMenu: 0,
            mapMenu: [0],
            sidebarItems: sidebarMenu
        }
    },
    components: {
        showCategories,
        SidebarItem,
        SupplierCategories
    },
    watch: {
        currentMenu: function(n, o) {
            if(n !== o) {
                if(this.mapMenu.indexOf(n) !== -1) {
                    this.mapMenu = this.mapMenu.slice(0,this.mapMenu.indexOf(n)+1);
                }else {
                    this.mapMenu.push(n);
                }
            }
        }
    },
    methods: {
        ...mapActions('auth', ['logout']),
        backMenuTodefault(){
            this.currentMenu = 0
        },
        validateRules(rules){
            /* if the rule coming frong string is true, the menu gonna render */
            return eval(rules) ? true : false;
        },
        changeMenu(menu){
            let menuOption = JSON.parse(JSON.stringify(menu))
            if(menuOption.recursive){
                this.currentMenu = menuOption.toMenu
            }
            if(menuOption.toMenu == 0){
                this.currentMenu = 0
            }
            
        }
    }
}
</script>

<style scoped>
.list-group-item {
    background-color: #343a40;
}

.list-group-item:hover {
    background-color: #535e69;
}

.list-group-item.active, .list-group-item.active:hover, .list-group-item.active:focus {
    background-color: #535e69 !important;
}
</style>
